import React from 'react';
import PropTypes from 'prop-types';

const DEBOUNCE_MS = 300;

export function buildPreviewSrc(previewUrl, style, size, templateId, logoSignedId) {
  const params = new URLSearchParams();
  params.set('style', JSON.stringify(style));
  params.set('size', String(size));
  // A picked (unsaved) logo is the source when present; the saved-template logo
  // (via qr_code_template_id) is only used when nothing new was picked.
  if (logoSignedId) {
    params.set('logo_signed_id', logoSignedId);
  } else if (templateId != null) {
    params.set('qr_code_template_id', String(templateId));
  }
  return `${previewUrl}?${params.toString()}`;
}

class QrPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: buildPreviewSrc(
        props.previewUrl,
        props.style,
        props.size,
        props.templateId,
        props.logoSignedId,
      ),
      loading: false,
      failed: false,
    };
    this.timer = null;
  }

  componentDidUpdate(prev) {
    if (prev.style === this.props.style
      && prev.size === this.props.size
      && prev.logoSignedId === this.props.logoSignedId) return;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.setState({
        src: buildPreviewSrc(
          this.props.previewUrl,
          this.props.style,
          this.props.size,
          this.props.templateId,
          this.props.logoSignedId,
        ),
        loading: true,
        failed: false,
      });
    }, DEBOUNCE_MS);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { src, loading, failed } = this.state;
    const { uploadingLogo } = this.props;
    const busy = loading || uploadingLogo;
    return (
      <div className="qr-preview">
        <div className="qr-section-label">Preview</div>
        <div className="qr-preview-frame" data-testid="preview-panel">
          <img
            className="qr-preview-img"
            data-testid="qr-preview-img"
            src={src}
            alt="QR code preview"
            style={{ opacity: busy ? 0.5 : 1 }}
            onLoad={() => this.setState({ loading: false, failed: false })}
            onError={() => this.setState({ loading: false, failed: true })}
          />
          {busy && <span className="qr-preview-spinner" data-testid="preview-spinner" />}
        </div>
        {failed && (
          <div className="qr-preview-error" data-testid="preview-error">
            Preview unavailable — check your color and shape inputs.
          </div>
        )}
      </div>
    );
  }
}

QrPreview.propTypes = {
  previewUrl: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  templateId: PropTypes.number,
  logoSignedId: PropTypes.string,
  uploadingLogo: PropTypes.bool,
};

QrPreview.defaultProps = { templateId: null, logoSignedId: null, uploadingLogo: false };

export default QrPreview;
